import { InputLabelProps as InputLabelPropsType, TextField } from '@material-ui/core';
import { InputProps as StandardInputProps } from '@material-ui/core/Input/Input';
import { InputBaseComponentProps } from '@material-ui/core/InputBase/InputBase';
import React, { ReactNode, useState } from 'react';

import { Value } from '@/model/common';
import { Func } from '@/utils/ts';

export interface TextFieldInputProps {
  'data-test'?: string;
  InputProps?: Partial<Omit<StandardInputProps, 'disableUnderline' | 'inputComponent'>>;
  InputLabelProps?: Partial<InputLabelPropsType>;
  inputComponent?: React.ElementType<InputBaseComponentProps>;
  value?: Value<string>;
  onChange?: Func<[string]>;
  messages?: {
    helperText?: ReactNode;
    label?: ReactNode;
    error?: ReactNode;
  };
}

const TextFieldInput: React.FC<TextFieldInputProps> = ({
  'data-test': dataTest,
  InputProps,
  InputLabelProps,
  inputComponent,
  value,
  onChange,
  messages,
}) => {
  const [isFocussed, setFocussed] = useState<boolean>(false);
  return (
    <TextField
      data-test={dataTest}
      /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      InputLabelProps={{ ...InputLabelProps, 'data-test': dataTest && `${dataTest}-label` }}
      variant="filled"
      InputProps={{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        'data-test': dataTest && `${dataTest}-input`,
        disableUnderline: true,
        ...(inputComponent ? { inputComponent } : {}),
        ...InputProps,
      }}
      label={messages?.label}
      value={value?.value || ''}
      onChange={async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        if (!onChange) {
          return;
        }
        const inputValue = event.target.value;
        if (inputValue !== value?.value) {
          await onChange(inputValue);
        }
      }}
      onFocus={(): void => setFocussed(true)}
      onBlur={(): void => setFocussed(false)}
      {...(value?.hasError && !isFocussed
        ? {
            helperText: messages?.error,
            error: true,
          }
        : { helperText: messages?.helperText })}
      // FIXME: best place to trim, but onBlur handler stopping event propagation, so i.e submit does't work at all
      // onBlur={async (event: React.FocusEvent<HTMLInputElement>): Promise<void> => {
      //   const inputValue = event.target.value?.trim();
      //   await onChange(inputValue);
      // }}
    />
  );
};

export default TextFieldInput;
